export default __webpack_public_path__ + "static/media/hrs logo.27290bf3.png";